import {
    combineReducers,
    configureStore,
    PayloadAction
} from '@reduxjs/toolkit'
import {
    clientSearchReducer,
    targetListReducer,
    interactionsReducer,
    notificationReducer,
    veInteractionsReducer,
    veSearchReducer,
    lastVisitedClientReducer
} from '../reducers'
import fcMetricsReducer from 'features/fcMetrics/fcMetricsSlice'
import vesReducer from 'features/ves/vesSlice'
import veReducer from 'features/ve/veSlice'
import paymentCelebrationReducer from 'features/paymentCelebration/paymentCelebrationSlice'
import storedVeDepositReducer from 'features/veDeposits/storedVeDepositsSlice'
import { authReducer } from 'features/auth/authSlice'
import { AuthSliceNamesEnum } from 'storeTypes'
import { veCardInventoryReducer } from 'features/card/veCardInventorySlice'
import { navbarReducer } from 'features/navbar/navbarSlice'
import { mobilePaymentReducer } from 'features/mobilePayment/mobilePaymentSlice'
import fcHomeReducer from 'features/fcHome/fcHomeSlice'
import homeReducer from 'features/home/homeSlice'
import transactionsReducer from 'features/transactions/transactionSlice'
import userPermissionsReducer from 'features/userPermissions/userPermissionsSlice'
import veDepositReducer from 'features/veDeposits/veDepositSlice'
import rankingReducer from 'features/ranking/rankingSlice'
import enrollmentReducer from 'features/enrollment/enrollmentSlice'
import {
    villagePreviousClientReducer,
    villageClientReducer,
    openVillagePageReducer,
    singleClientReducer,
    villageSelectionInfoReducer,
    multipleVillagesCountReducer,
    veClientListReducer,
    filterSelectorReducer
} from 'features/villageClient/villageClientSlice'
import bulkEnrollmentReducer from 'features/bulkEnrollment/bulkEnrollmentSlice'
import { enrollmentRecapReducer } from 'features/enrollmentRecap/enrollmentRecapSlice'
import {
    setIsVisitedReducer,
    setShowWarningReducer
} from 'features/visit/visitSlice'
import {
    clientOrdersReducer,
    villageClientOrdersReducer
} from 'features/clientOrders/clientOrdersSlice'

const appReducer = combineReducers({
    auth: authReducer,
    navbar: navbarReducer,
    villagePreviousClientList: villagePreviousClientReducer,
    enrollment: enrollmentReducer,
    villageClientList: villageClientReducer,
    veClientList: veClientListReducer,
    veRankingList: rankingReducer,
    openVillagePage: openVillagePageReducer,
    filterSelection: filterSelectorReducer,
    veDeposit: veDepositReducer,
    userPermissions: userPermissionsReducer,
    clientSearch: clientSearchReducer,
    singleClient: singleClientReducer,
    villageSelectionInfo: villageSelectionInfoReducer,
    villageClientOrders: villageClientOrdersReducer,
    clientOrders: clientOrdersReducer,
    targetList: targetListReducer,
    interactions: interactionsReducer,
    veInteractions: veInteractionsReducer,
    isVisited: setIsVisitedReducer,
    showWarning: setShowWarningReducer,
    multipleVillagesCount: multipleVillagesCountReducer,
    transactions: transactionsReducer,
    notifications: notificationReducer,
    fcMetrics: fcMetricsReducer,
    ves: vesReducer,
    cardInventoryState: veCardInventoryReducer,
    ve: veReducer,
    storedVeDeposit: storedVeDepositReducer,
    veSearch: veSearchReducer,
    paymentCelebrationState: paymentCelebrationReducer,
    lastVisitedClient: lastVisitedClientReducer,
    mobilePayment: mobilePaymentReducer,
    fcHome: fcHomeReducer,
    home: homeReducer,
    bulkEnrollment: bulkEnrollmentReducer,
    enrollmentRecap: enrollmentRecapReducer
})

export const rootReducer = (
    state: ReturnType<typeof appReducer> | undefined,
    action: PayloadAction
) => {
    if (action.type === AuthSliceNamesEnum.AUTH_LOGOUT) {
        return appReducer(undefined, action) // Reset state
    }
    return appReducer(state, action)
}

export const configStore = () => {
    return configureStore({
        reducer: rootReducer
    })
}

const store = configStore()

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
